<template>
  <div class="hello">
    <div>
      <b-modal id="modal-suggest">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSdFnu9Ne8XeNvqhWxocU63_X2zwyra1Bg4o8Vn0kyw4wU5wRQ/viewform?embedded=true"
          width="450" height="506" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </b-modal>



      <b-form>
        <b-form-group id="input-group-provider" label="Select sample APIs or use your custom one" label-for="input-1"
          description="Use a sample API key provider or create a custom one" v-if="isShowbtn">

          <div class="d-flex flex-row pb-1" style="overflow: auto;">
            <div v-bind:key="apiProvider.id" v-for="apiProvider in apiProviders"
              v-on:click="selectApiProvider(apiProvider)">
              <input v-bind:key="apiProvider.id" type="radio" name="emotion" v-model="selectedApi" :value="apiProvider.id"
                :id="apiProvider.id" class="input-hidden" />
              <label :for="apiProvider.id" style="opacity: 1.0;">
                <img :src="getImgUrl(apiProvider.imageUrl)" class="provider_style mr-3" :alt="apiProvider.name"
                  :title="apiProvider.name" />
              </label>
            </div>
            <div id="other_btn" v-on:click="otherSelected" class="other_btn">
              Custom
            </div>


            <!--            <div class="vertical_line mr-3 ml-3"></div>

            <v-select
              :options="allApiProviders"
              v-model="selectedApi"
              :searchable="true"
              class="pt-2"
            />

            <select id="mySelect" data-show-content="true" class="form-control">
                <option>Select..</option>
                <option v-bind:key=" 'a_' +apiProvider.id" v-for="apiProvider in allApiProviders">
                  {{apiProvider.name}}
                </option>

            </select>-->
          </div>
        </b-form-group>
        <b-input-group id="input-group-key" prepend="Auth key" class="mb-3">
          <b-form-input v-model="key" id="inline-form-input-key" ref="key" class="mb-sm-0 pl-3"
            placeholder="X-API-Key, Authorization" :disabled='isKeyisDisabled' style="color: black;"></b-form-input>
        </b-input-group>

        <b-input-group id="input-group-value" class="mb-3">
          <b-input-group-prepend>


            <b-input-group-text>Auth value</b-input-group-text>
          </b-input-group-prepend>



          <b-form-input v-model="value" id="inline-form-input-value" placeholder="XXXXXXXXXX" class="mb-sm-0 pl-3"
            style="color: black;"></b-form-input>

          <b-input-group-append>
            <b-button v-on:click="openLink()" v-if="selectedApiProvider && selectedApiProvider.get">API DOCS <i
                class="las la-external-link-alt"></i></b-button>
          </b-input-group-append>
        </b-input-group>

        <b-input-group id="input-group-allowed-hosts" prepend="Allowed hosts" class="mb-3">
          <b-form-input v-model="allowedHosts" id="inline-form-input-allowed-hosts" ref="key" class="mb-sm-0 pl-3"
            placeholder="localhost,app.tesla.com" :disabled='isKeyisDisabled' style="color: black;"></b-form-input>
        </b-input-group>

        <b-form-group label="API key injection type (check API docs)" v-slot="{ ariaDescribedby }">
          <b-form-radio-group id="radio-group-1" v-model="selected" :options="options" :aria-describedby="ariaDescribedby"
            :disabled="isKeyisDisabled" name="radio-options"></b-form-radio-group>
        </b-form-group>

        <b-form-group label="HTTP method" v-slot="{ ariaDescribedby }">
          <b-form-radio-group id="radio-group-2" v-model="httpMethodSelected" :options="httpMethodOptions"
            :aria-describedby="ariaDescribedby" :disabled="isKeyisDisabled"
            name="radio-options-http-method"></b-form-radio-group>
        </b-form-group>


        <b-input-group id="input-group-1" prepend="Email" description="We'll never share your email with anyone else.">
          <b-form-input type="email" id="inline-form-input-email" class=" mb-sm-0 pl-3" placeholder="elon@tesla.com"
            v-model="email" style="color: black;" :state="validateEmail()"></b-form-input>
        </b-input-group>
        <small>We will only send transactional emails related to your account.</small>

        <div v-if="error" class="p-3 m-2" style="background-color: white;">
          <p style="color: red;"><b>{{ error }}</b></p>
        </div>

        <b-button class="mt-4 contact-widget-wrap" variant="primary" v-on:click="save" :disabled="!buttonEnabled">Hide
          your API key*</b-button>
      </b-form>
      <small class="mb-2">* 24 hour trial, €$£<b>1</b> excl. VAT/month afterwards</small>
      <!--  -->
      <div v-if="url">
        <b-form>
          <b-form-group id="input-group-1" label="Enter your existing API URL:" label-for="input-1"
            description="Enter your current API URL.">
            <b-form-input v-model="existingUrl" type="url" id="inline-form-input-email" class="mb-2 mb-sm-0"
              style="color: black;" placeholder="https://api.example.com/endpoint"></b-form-input>
          </b-form-group>

          <small>Remove the API key and replace your current API URL with:</small>
          <b-input-group id="input-group-1" label-for="input-1">
            <b-form-input v-model="concatenatedUrl" type="url" id="inline-form-input-email" class="mb-2 mb-sm-0"
              style="color: black;" readonly></b-form-input>
            <b-input-group-prepend>
              <b-button v-on:click="copyURLToClipboard($event)"><i class="fa-solid fa-copy"></i></b-button>
            </b-input-group-prepend>
          </b-input-group>

          <code
            style="display:block; color: blue; background-color: white; margin: 0 auto; font-size: 120%; text-align: left; padding: 15px;"
            class="my-3">{{ curl }}</code>
          <a v-on:click="runInInsomnia"><img src="https://insomnia.rest/images/run.svg" class="mt-2 mb-3"></a>

        </b-form>
        <div style="border: solid;" class="p-3">
          <h2 class="text-center" style="color: white;"><i class="las la-envelope-open center"></i></h2>

          <p>We sent a welcome email to <code>{{ email }}</code> with further
            instructions how to continue after the trial period.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BForm } from "bootstrap-vue/esm/components/form/form";
import { BFormGroup } from "bootstrap-vue/esm/components/form-group/form-group";
import { BModal } from "bootstrap-vue/esm/components/modal/modal";
import { BFormInput } from "bootstrap-vue/esm/components/form-input/form-input";
import { BInputGroup } from "bootstrap-vue/esm/components/input-group/input-group";
import { BInputGroupPrepend } from "bootstrap-vue/esm/components/input-group/input-group-prepend";
import { BInputGroupText } from "bootstrap-vue/esm/components/input-group/input-group-text";
import { BButton } from "bootstrap-vue/esm/components/button/button";
import { BInputGroupAppend } from "bootstrap-vue/esm/components/input-group/input-group-append";
import { BFormRadioGroup } from "bootstrap-vue/esm/components/form-radio/form-radio-group";
import VSelect from "@alfsnd/vue-bootstrap-select";

export default {
  name: "HelloWorld",
  components: {
    BForm,
    BFormGroup,
    BModal,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroupText,
    BFormRadioGroup,
    Clipboard,
    VSelect
  },
  data() {
    return {
      api_host: process.env.VUE_APP_API_HOST,
      postmanHost: process.env.POSTMAN_API_HOST || "https://api.getpostman.com",
      postmanApiKey: process.env.VUE_APP_POSTMAN_API_KEY,
      workspaceId: process.env.WORKSPACE_ID || "f40b3417-8151-4396-bd48-f8789ac2cea7",
      key: "",
      value: "",
      allowedHosts: "",
      email: "",
      url: "",
      apiUrl: "",
      existingUrl: "",
      selectedApi: "",
      error: "",
      apiProviders: [
        {
          id: "openai_completions",
          name: "OpenAI Completions",
          apiUrl: "https://api.openai.com/v1/completions",
          imageUrl: "/img/openai.webp",
          key: "Authorization",
          value: "Bearer ",
          type: "header",
          get: "https://platform.openai.com/account/api-keys",
          route: "/hide-openai-api-key",
          method: "POST"
        },
        {
          id: "openai_models",
          name: "OpenAI Models",
          apiUrl: "https://api.openai.com/v1/models",
          imageUrl: "/img/openai.webp",
          key: "Authorization",
          value: "Bearer ",
          type: "header",
          get: "https://platform.openai.com/account/api-keys",
          route: "/hide-openai-api-key",
          method: "GET"
        },
        {
          id: "pexels",
          name: "Pexels",
          apiUrl: "https://api.pexels.com/v1/search?query=people",
          imageUrl: "/img/pexels.png",
          key: "Authorization",
          type: "header",
          get: "https://www.pexels.com/api/new/",
          route: "/hide-pexels-api-key",
          method: "GET"
        },
        {
          id: "pixabay",
          name: "Pixabay",
          apiUrl: "https://pixabay.com/api/",
          imageUrl: "/img/pixabay.png",
          key: "key",
          type: "query",
          get: "https://pixabay.com/api/docs/",
          route: "/hide-pixabay-api-key",
          method: "GET"
        },
        {
          id: "removebg",
          name: "remove.bg",
          apiUrl: "https://api.remove.bg/v1.0/removebg",
          imageUrl: "/img/removebg.png",
          key: "X-API-Key",
          type: "header",
          get: "https://www.remove.bg/dashboard#api-key",
          route: "/hide-removebg-api-key",
          method: "POST"
        },
        {
          id: "unscreen",
          name: "unscreen.com",
          apiUrl: "https://api.unscreen.com/v1.0/videos",
          imageUrl: "/img/unscreen.png",
          key: "X-Api-Key",
          type: "header",
          get: "https://www.unscreen.com/dashboard#api-key",
          route: "/hide-unscreen-api-key",
          method: "POST"
        },
        {
          id: "googlemaps",
          name: "Google Maps",
          apiUrl: "https://maps.googleapis.com/maps/api/js?callback=initMap",
          imageUrl: "/img/google_map.png",
          key: "X-Api-Key",
          get: "https://developers.google.com/maps/documentation/javascript/get-api-key",
          type: "query",
          route: "/hide-google-maps-api-key"
        },
        {
          id: "adExchangeBuyerAPI",
          name: "Ad Exchange Buyer API",
          apiUrl: "https://www.googleapis.com/auth/adexchange.buyer",
          get: "https://developers.google.com/authorized-buyers/apis/guides/start",
          key: "key",
          type: "header",
          imageUrl: "/img/authorized_buyers.png",
        },
        {
          id: "adExchangeSellerAPI",
          name: "Ad Exchange Seller API",
          apiUrl: "https://www.googleapis.com/auth/dfp",
          imageUrl: "/img/admanager.png",
          key: "Authorization",
          value: "Bearer ",
          type: 'form',
          get: "https://developers.google.com/ad-manager/api/authentication",
          method: "POST"
        },
        {
          id: "adminDataTransferAPI",
          name: "Admin Data Transfer API",
          apiUrl: "https://admin.googleapis.com/admin/datatransfer/v1/applications",
          imageUrl: "/img/workspaceadmin.png",
          key: "key",
          type: 'header',
          get: "https://developers.google.com/admin-sdk/data-transfer",
          method: "GET"
        },
        {
          id: "play.ht",
          name: "Play.ht Stream",
          apiUrl: "https://play.ht/api/v2/tts/stream",
          imageUrl: "/img/playht.svg",
          key: "AUTHORIZATION",
          type: 'header',
          get: "https://docs.play.ht/reference/api-generate-tts-audio-stream",
          method: "GET"
        }
        /*{
          id: 'raetselinos',
          name: "Rätselinos",
          apiUrl: "https://api.raetselinos.eu/generate/sudoku/easy/1",
          imageUrl: "/img/raetselinos.png",
          key: "key",
          get: "https://app.raetselinos.eu/"
        },*/
      ],
      selectedApiProvider: undefined,
      selected: 'header',
      options: [
        { text: 'Header', value: 'header' },
        { text: 'Query', value: 'query' },
        { text: 'Form Data', value: 'form' },
        { text: 'Cookie', value: 'cookie', disabled: true }
      ],
      httpMethodOptions: [
        { text: 'GET', value: 'GET' },
        { text: 'POST', value: 'POST' },
        { text: 'HEAD', value: 'HEAD' },
        { text: 'PUT', value: 'PUT' },
        { text: 'DELETE', value: 'DELETE' },
        { text: 'OPTIONS', value: 'OPTIONS' },
        { text: 'TRACE', value: 'TRACE' },
        { text: 'PATCH', value: 'PATCH' },

      ],
      httpMethodSelected: 'GET',
      isShowbtn: true,
      isKeyisDisabled: false,
      buttonEnabled: true,
    };
  },
  mounted: function () {
    $("#other_btn").addClass("active-button");


    const index = this.apiProviders.findIndex(obj => obj.route == this.$route.path)
    if (index > -1) {
      this.selectedApiProvider = this.apiProviders[index];
      this.key = this.apiProviders[index].key
      this.existingUrl = this.apiProviders[index].apiUrl
      this.isShowbtn = false
      this.isKeyisDisabled = true;
    } else {
      this.isShowbtn = true
    }
  },
  computed: {
    curl: function () {
      return `$ curl -X ${this.httpMethodSelected} \n-f ${this.concatenatedUrl}`;
    },
    concatenatedUrl: function () {
      return this.url + this.existingUrl;
    },
  },
  methods: {
    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },
    runInInsomnia() {
      const aTag = document.createElement('a')
      aTag.href = `https://insomnia.rest/run/?label=hideAPIkey.com%20relay&uri=${this.api_host}insomnia/${this.concatenatedUrl}`;
      aTag.target = "_blank"
      aTag.click()
    },
    openLink(link) {
      window.open(this.selectedApiProvider.get, "_blank");
    },
    otherSelected(e) {
      e.stopPropagation();
      $("#other_btn").addClass("active-button");
      this.selectedApi = "other";
      this.selectedApiProvider = undefined;
      this.key = "";
      this.existingUrl = "";
      this.$forceUpdate();
    },
    getImgUrl(imgUrl) {
      return imgUrl;
    },
    selectApiProvider(apiProvider) {
      $("#other_btn").removeClass("active-button");
      this.selectedApiProvider = apiProvider;
      this.key = apiProvider.key;
      this.value = apiProvider.value;
      this.existingUrl = apiProvider.apiUrl;
      this.selected = apiProvider.type;
      this.httpMethodSelected = apiProvider.method;
    },
    save(event) {
      let that = this;
      this.error = "";
      if (this.email == "") {
        this.error += "Email required. ";
      } else {
        if (!this.validateEmail()) {
          this.error += "Valid email required. ";
        }
      }
      if (this.key == "") {
        this.error += "API Header Key required. ";
      }
      if (this.value == "") {
        this.error += "API Key required. ";
      }
      if (this.error) {
        this.error = "Error(s): " + this.error;
        return;
      }
      axios
        .post(`${that.api_host}hideapikey`, {
          type: "inject",
          email: this.email,
          key: this.key,
          value: this.value,
          type: this.selected,
          allowedHosts: this.allowedHosts,
        })
        .then(function (response) {
          that.url = response.data.relayUrl;
          that.buttonEnabled = false;
          //console.log(response);
        })
        .catch(function (error) {
          console.err(error);
        });
    },
    copyURLToClipboard(event) {
      event.currentTarget.innerText = "COPIED!";
      this.$clipboard(this.concatenatedUrl);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.input-group-text {
  background-color: #eeeeee;
}


.input-group-text {
  color: black;
}
</style>
